import React from 'react';
import { Box } from '@mui/material';


const PageLayout = ({ children, sx = {}, maxWidth }) => (
  <Box
    sx={{
      px: { xs: 2, sm: 3, md: 4 },
      py: { xs: 2, sm: 3 },
      width: '100%',
      maxWidth: maxWidth || '100%',
      boxSizing: 'border-box',
      fontFamily: "'Fira Sans', sans-serif",
      ...sx,
    }}
  >
    {children}
  </Box>
);

export default PageLayout;
